import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'whitePoint';

export class WhitePoint extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
